import React, { useState } from "react";
import "../styles/SlideMenu.css";

const SlideMenu = ({ initialMode, changeMode }) => {
  const [mode, setMode] = useState(initialMode);

  const handleChange = () => {};

  function changeSection(newSection) {
    setMode(newSection);
    changeMode(newSection);
  }

  return (
    <div className="slidemenu">
      {/* 1 */}
      <input
        type="radio"
        name="slideItem"
        id="slide-item-1"
        className="slide-toggle"
        checked={mode === "details"}
        onClick={() => changeSection("details")}
        onChange={handleChange}
      />
      <label htmlFor="slide-item-1">
        <span>EDIT DETAILS</span>
      </label>
      {/* 2 */}
      <input
        type="radio"
        name="slideItem"
        id="slide-item-2"
        className="slide-toggle"
        checked={mode === "develop"}
        onClick={() => changeSection("develop")}
        onChange={handleChange}
      />
      <label htmlFor="slide-item-2">
        <span>DEVELOP</span>
      </label>

      {/* 3 */}
      <input
        type="radio"
        name="slideItem"
        id="slide-item-3"
        className="slide-toggle"
        checked={mode === "resources"}
        onClick={() => changeSection("resources")}
        onChange={handleChange}
      />
      <label htmlFor="slide-item-3">
        <span>RESOURCES</span>
      </label>

      {/* bar */}
      <div className="slider">
        <div className="bar"></div>
      </div>
    </div>
  );
};

export default SlideMenu;
